import _ from 'lodash'

export default {
  colors: ['#C1272D', '#ED1C24', '#F7931E', '#FCEE21', '#39B54A', '#006837', '#00A99D', '#29ABE2', '#0071BC', '#662D91', '#9E005D'],

  flattenDictionary (index, iterable) {
    let countingArray = []
    _.forEach(iterable, function (value, key) {
      countingArray.push([parseInt(key), index, value])
    })
    return countingArray
  },
  countValuesInListOfDictionaries (listOfDictionaries, key) {
    let countingData = {}
    _.forEach(listOfDictionaries, function (dictionary) {
      if (dictionary[key] in countingData) {
        countingData[dictionary[key]]++
      } else {
        countingData[dictionary[key]] = 1
      }
    })
    return countingData
  },
  countValuesInListOfDictionariesForPieChart (listOfDictionaries, key) {
    let countingData = {}
    _.forEach(listOfDictionaries, function (dictionary) {
      if (dictionary[key] in countingData) {
        countingData[dictionary[key]]++
      } else {
        countingData[dictionary[key]] = 1
      }
    })
    let pieChart = []
    _.forEach(countingData, function (value, key) {
      pieChart.push({'value': value, 'name': key})
    })
    pieChart.sort((a, b) => b.value - a.value)

    return pieChart
  },
  convertDictionaryToXAxisPosition (xAxis, dictionary) {
    let countingData = {}
    _.forEach(dictionary, function (value, key) { countingData[xAxis.indexOf(parseInt(key))] = value })
    return countingData
  }

}



// WEBPACK FOOTER //
// ./src/utils/index.js